export default __webpack_public_path__ + "static/media/Icon -Appointment Period.634514b1.svg";